import { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

import { userType } from "../../../constant/WebToLead";
import {
  googleRegister,
  outlookRegister,
  userRegister,
} from "../../../actionCreator/signUpActionCreater";
import { AuthContext } from "../../../context/AuthContext";
import { getAccountInfo } from "../../../actionCreator/commonActionCreator";
import { countries } from "../../../constant/Countries";

export const useRegister = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { login } = useContext(AuthContext);
  const loading = useSelector(
    (state) => state.CommonReducer.loading["register"]
  );

  const [error, setError] = useState("");

  const handleCreateAccount = async (values, user, type, oauth2Token) => {
    const [firstName, ...lastName] = values?.fullName
      ? values?.fullName.trim().split(" ")
      : ["", ""];

    const formattedPayload = oauth2Token
      ? {
          ...values,
          firstName: user?.firstName,
          lastName: user?.lastName,
          email: user?.email,
          password:
            type === "signup-outlook"
              ? "azure_authenticated"
              : "gmail_authenticated",
          userType:
            type === "signup-outlook" ? userType.AZURE : userType.GOOGLE,
          oauth2Token: oauth2Token,
          mobileNo: values?.mobileNo
            ? "+" +
              countries?.find((d) => d?.label === values?.prefix)?.code +
              " " +
              values?.mobileNo
            : null,
        }
      : {
          ...values,
          firstName: firstName,
          lastName: lastName.join(" "),
          userType: userType.NATIVE,
          mobileNo: values?.mobileNo
            ? "+" +
              countries?.find((d) => d?.label === values?.prefix)?.code +
              " " +
              values?.mobileNo
            : null,
        };
    let res;
    switch (type) {
      case "signup-outlook":
        res = await dispatch(outlookRegister(formattedPayload));
        break;
      case "signup-google":
        res = await dispatch(googleRegister(formattedPayload));
        break;
      default:
        res = await dispatch(userRegister(formattedPayload));
    }

    if (res?.status === 201) {
      navigate(
        `/signup?key=${res?.data?.activationKey}&email=${formattedPayload?.email}`
      );
    } else if (
      res?.status === 200 &&
      res?.data?.token &&
      ["signup-outlook", "signup-google"]?.includes(type)
    ) {
      login(res?.data?.token, true);
      dispatch(getAccountInfo(res?.data?.token));
      navigate("/dashboard-view");
    } else if (res?.status === 400) {
      setError(res?.title || "Invalid details provided.");
    } else {
      setError("Something went wrong. Please try again.");
    }
  };

  return { handleCreateAccount, loading, error };
};
